export type LicenseWindowStatus = "past" | "current" | "future";

export type ActivityType = "initial_import" | "field_update" | "slate_activity";

export interface CatalogActivityEntry {
    id: string;
    type: ActivityType;
    timestamp: string;
    actor?: string;
    summary?: string;
    changes?: Array<{ field: string; from?: string; to?: string }>;
}

export interface CatalogLicenseWindow {
    window_index: number;
    playback_start_date: string | number;
    playback_end_date: string | number;
    coming_soon_date: string | number;
    status: LicenseWindowStatus;
}

export interface CatalogRelationshipsAsset {
    ref_id: string;
    content_type: string;
    title: string;
    episode_number?: number | null;
    season_number?: number | null;
    clickable: boolean;
}

export interface CatalogRelationshipsSeason {
    season_ref_id: string;
    season_number?: number | null;
    season_title: string;
    assets: CatalogRelationshipsAsset[];
}

export interface CatalogRelationships {
    family_ref_id?: string;
    series_ref_id: string;
    series_title: string;
    season_ref_id: string;
    season_number?: number | null;
    season_title: string;
    assets: CatalogRelationshipsAsset[];
    seasons?: CatalogRelationshipsSeason[];
}

/** @deprecated Use CatalogRelationships */
export type CatalogHierarchy = CatalogRelationships;
/** @deprecated Use CatalogRelationshipsAsset */
export type CatalogHierarchyAsset = CatalogRelationshipsAsset;

export interface AvailsPlusCatalogDetail {
    reference_id: string;
    name: string;
    content_type: string;
    licensor: string;
    license_type: string;
    format_profile: string;
    branding_rights: string;
    hdr: string;
    license_rights_description: string;
    season_number?: number | null;
    episode_number?: number | null;
    episode_count?: number | null;
    season_count?: number | null;
    series_ref_id?: string;
    season_ref_id?: string;
    series_title?: string;
    season_title?: string;
    version: number;
    license_windows: CatalogLicenseWindow[];
    activity: CatalogActivityEntry[];
    relationships?: CatalogRelationships | null;
    /** @deprecated Use relationships */
    hierarchy?: CatalogRelationships | null;
    created_at?: string;
    updated_at?: string;
}

export const ACTIVITY_TYPE_LABELS: Record<ActivityType, string> = {
    initial_import: "Initial import",
    field_update: "Field update",
    slate_activity: "Slate activity",
};
